import React, { Component } from "react";
import { connect } from "react-redux";
import Immutable, { is } from "immutable";
import FontAwesome from "react-fontawesome";

import Modal from '@mawesi-sas/mws_react_component_modal';
import Input from '@mawesi-sas/mws_react_component_input';
import ButtonStrip from "../../Layout/components/ButtonStrip";
import BoxButton from "../../Layout/components/BoxButton";

import { showHideModalGenerateInterfaz, generateInterfaz } from "../actions";

class ModalGenerateInterfaz extends Component {
  modalContent = () => {
    const buttons = [];
    buttons.push(
      <BoxButton
        key="ba[-1][0]"
        name="check"
        title="Aceptar"
        disabled={this.props.saving}
      />
    );

    return (
      <form
        id="form"
        onSubmit={e => {
          e.preventDefault();
          this.props.generateInterfaz();
        }}
        noValidate
      >
        <ButtonStrip actions={buttons} />
        <div>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label className="control-label">Número de registro</label>
                <Input
                  type="number"
                  reducer="interfazcontable"
                  path="modalGenerateInterfaz.data.consecutivo"
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label className="control-label">Notas encabezado</label>
                <Input
                  type="textarea"
                  reducer="interfazcontable"
                  path="modalGenerateInterfaz.data.notas"
                />
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  };

  render() {
    const { modalGenerateInterfaz } = this.props;

    return (
      <Modal
        ancho="400px"
        mostrar={modalGenerateInterfaz.get("show")}
        contenido={this.modalContent()}
        titulo="Generación de archivos de interfaz"
        nombre="modal_generar_interfaz_contable"
        onCerrarModal={() => this.props.showHideModalGenerateInterfaz(false)}
      />
    );
  }
}

const mapStateToProps = (state, onwProps) => {
  return {
    modalGenerateInterfaz: state.interfazcontable.get("modalGenerateInterfaz"),
    saving: state.interfazcontable.get("saving")
  };
};

const mapDispatchToProps = {
  showHideModalGenerateInterfaz,
  generateInterfaz
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalGenerateInterfaz);
